import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('toolbar',{attrs:{"mode":"dataset","title":"Compile","view":"list"}}),_c('dataset',{ref:"dataset",on:{"submitted":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }